import React from "react";
import "./spinner.scss";
import loaderGif from "../../assets/loader.gif";

export default function LoadingSpinner({ appLanding, topMargin, width }) {
  return (
    <div
      className={
        appLanding
          ? "tpt-app-loading-spinner text-center"
          : "tpt-loading-spinner text-center"
      }
      style={{ top: `${topMargin}px`, width: `${width}%` }}
      data-testid="loading-spinner"
    >
      <img src={loaderGif} alt="Loading..." className="loader-icon" />
    </div>
  );
}

LoadingSpinner.defaultProps = {
  topMargin: 25,
  width: 90,
};
